import { render, staticRenderFns } from "./notificacao-push-perfil.vue?vue&type=template&id=17fe1b6e&scoped=true"
import script from "./notificacao-push-perfil.vue?vue&type=script&lang=ts"
export * from "./notificacao-push-perfil.vue?vue&type=script&lang=ts"
import style0 from "./notificacao-push-perfil.vue?vue&type=style&index=0&id=17fe1b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe1b6e",
  null
  
)

export default component.exports